import { render, staticRenderFns } from "./AddDepositPanel.vue?vue&type=template&id=20146d81&scoped=true&"
import script from "./AddDepositPanel.vue?vue&type=script&lang=js&"
export * from "./AddDepositPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddDepositPanel.vue?vue&type=style&index=0&id=20146d81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20146d81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20146d81')) {
      api.createRecord('20146d81', component.options)
    } else {
      api.reload('20146d81', component.options)
    }
    module.hot.accept("./AddDepositPanel.vue?vue&type=template&id=20146d81&scoped=true&", function () {
      api.rerender('20146d81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/control-center/AddDepositPanel.vue"
export default component.exports